export class Script {
  static append(src){
    var promise = new Promise(function(resolve, reject){
      var script = document.createElement("script");
      var body   = document.getElementsByTagName("body")[0];

      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      script.src = src;

      body.appendChild(script);
    });

    return promise;
  }
}
